import { IMember } from "@wingspanhq/users/dist/lib/interfaces";
import { components } from "../../../services/api/onboarding/types";

export const selectorCanEnableTaxWithholdings = (
  monitoredEntity?: components["schemas"]["CustomerEntity"],
  member?: IMember
) =>
  (monitoredEntity?.country === "US" ||
    member?.profile.address?.country === "US") ??
  true;
